import { createAction } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../constants';
/**
 *
 * @documented
 * @category Action
 * @example
 *
 * 	dispatch(setCachedRequest({ requestUuid: String, data: any, timestamp: Number, cacheKey: String, staleTime: Number }));
 *
 */ export const setCachedRequest = createAction(actionTypes.SET_REQUEST);
/**
 *
 * @documented
 * @category Action
 * @example
 *
 * 	dispatch(updateCachedRequest({ requestUuid: String, data: any, cached: Boolean, cacheKey: String, staleTime: Number }));
 *
 */ export const updateCachedRequest = createAction(actionTypes.UPDATE_REQUEST);
/**
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(clearCachedRequest(cacheKey));
 *
 */ export const clearCachedRequest = createAction(actionTypes.CLEAR_REQUEST);
/**
 *
 * Resets whole cache state
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(reset());
 *
 */ export const reset = createAction(actionTypes.RESET);
export default {
    setCachedRequest,
    clearCachedRequest,
    reset
};
